module.exports = __webpack_public_path__ + "img/section3_icon3_m.05a3d21e.png";